import dayjs from 'dayjs';
import { localizeDate } from 'shared/utils/localizeDate';

/**
 * [getPresentDateRange] Present is the start of 2 months in the past and the end of the current month
 * e.g. October -> 8/1/2020 to 10/31/2020
 * @returns {{min: number, max: number}}  returns an object with min as 2 months ago
 * in YYYYMMDD format, and max as the last day of the current month in YYYYMMDD format
 */

export const getPresentDateRange = (options?: { localizedFormat?: boolean }) => {
  const format = options?.localizedFormat ? localizeDate('YYYYMMDD') : 'YYYYMMDD';
  return {
    min: dayjs().startOf('month').subtract(2, 'month').format(format),
    max: dayjs().endOf('month').format(format),
  };
};
